(() => {
  'use strict';
  const mobile = window.matchMedia('(max-width: 749px)');
  let scheduled = false;
  const intersects = (a, b) => a.width > 0 && a.height > 0 && b.width > 0 && b.height > 0 && a.left < b.right + 8 && a.right > b.left - 8 && a.top < b.bottom + 8 && a.bottom > b.top - 8;
  function update() {
    scheduled = false;
    // This app heading is injected after the theme renders. Keep its appearance.
    if (document.body.dataset.klHomepage === 'true') {
      document.querySelectorAll('h1.gr-widget-title').forEach(old => {
        const heading = document.createElement('h2');
        const style = getComputedStyle(old);
        for (const attr of old.attributes) heading.setAttribute(attr.name, attr.value);
        for (const prop of ['font-size', 'font-weight', 'font-family', 'line-height', 'letter-spacing', 'margin-top', 'margin-bottom']) heading.style.setProperty(prop, style.getPropertyValue(prop));
        heading.append(...old.childNodes);
        old.replaceWith(heading);
      });
    }
    const regions = mobile.matches ? Array.from(document.querySelectorAll('.price, .product-form__buttons, .quick-add, .card__heading, .card-information')).map(e => e.getBoundingClientRect()).filter(r => r.bottom > 0 && r.top < innerHeight) : [];
    const chat = document.querySelector('shopify-chat');
    const runtime = chat?.shadowRoot?.querySelector('shopify-agent-runtime');
    const activator = runtime?.shadowRoot?.querySelector('[part="activator"]');
    const dialog = runtime?.shadowRoot?.querySelector('[part="dialog"]');
    if (chat && activator) {
      const open = dialog && dialog.getBoundingClientRect().height > 0;
      chat.toggleAttribute('data-kl-purchase-overlap', !open && regions.some(r => intersects(activator.getBoundingClientRect(), r)));
    }
    const badge = document.getElementById('google-merchantwidget-iframe-wrapper');
    if (badge) {
      const box = badge.getBoundingClientRect();
      // Do not hide an expanded Google review dialog.
      badge.toggleAttribute('data-kl-purchase-overlap', box.width <= 120 && box.height <= 120 && regions.some(r => intersects(box, r)));
    }
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule);
  mobile.addEventListener('change', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
  // Allow asynchronous widget shadow roots to finish mounting.
  setTimeout(schedule, 1500);
  setTimeout(schedule, 4000);
})();
